import React, { useEffect, useState } from 'react';
import { PDFViewer, Page, Text, Image, View, Document, Font } from '@react-pdf/renderer';
import { cnpjMask } from '../../services/cnpj';
import Carregando from '../CarregandoComponent';
import { isAdminProfile } from '../../services/profile';
import { getCertificadoAdmin, getCertificadoContribuinte } from '../../api/certificado';

function CertificateComponent({ cnpj, cpf }) {

  const [carregandoCertificado, setCarregandoCertificado] = useState(false);
  const [razaoSocial, setRazaoSocial] = useState(null);
  const [condicao, setCondicao] = useState(null);
  const [codigo, setCodigo] = useState(null);
  const [classificacao, setClassificacao] = useState(null);
  const [aquisicaoInicio, setAquisicaoInicio] = useState(null);
  const [aquisicaoFim, setAquisicaoFim] = useState(null);
  const [validadeInicio, setValidadeInicio] = useState(null);
  const [validadeFim, setValidadeFim] = useState(null);
  const [emitido, setEmitido] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    desabilitaHifenizacao();
    setCarregandoCertificado(true);
    if (isAdminProfile()) {
      getCertificadoAdmin(cnpj)
        .then(handleGetCertificado)
        .catch(console.error)
        .finally(() => setCarregandoCertificado(false));
    } else {
      getCertificadoContribuinte(cpf, cnpj)
        .then(handleGetCertificado)
        .catch(console.error)
        .finally(() => setCarregandoCertificado(false));
    }
  }, [cnpj, cpf]);

  function handleGetCertificado(resposta) {
    if (!!resposta && resposta.status && resposta.conteudo.length > 0) {
      setRazaoSocial(resposta.conteudo[0].razaoSocial);
      setCondicao(resposta.conteudo[0].condicao);
      setClassificacao(resposta.conteudo[0].classificacao);
      setAquisicaoInicio(resposta.conteudo[0].aquisicaoInicio);
      setAquisicaoFim(resposta.conteudo[0].aquisicaoFim);
      setValidadeInicio(resposta.conteudo[0].validadeInicio);
      setValidadeFim(resposta.conteudo[0].validadeFim);
      setCodigo(resposta.conteudo[0].codigo);
      setEmitido(resposta.conteudo[0].emitido);

    } else {
      setErro('Não foi possível carregar o certificado');
      console.error(resposta.mensagem);
    }
  };

  function desabilitaHifenizacao() {
    Font.registerHyphenationCallback(word => [word]);
  };

  function formatarData(data) {
    try {
      const regex = new RegExp(/\d{4}-\d{2}-\d{2}/);
      if (regex.test(data)) {
        const dateArray = data.split('-');
        return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
      } else {
        return data;
      }
    } catch (e) {
      console.error(e);
      return data;
    }
  };

  if (carregandoCertificado) {
    return <Carregando />;
  } else if (erro) {
    return <div>{erro}</div>;
  } else {
    return (
      <PDFViewer style={{ width: '100%', height: '1000px', }}>
        <Document>
          <Page orientation='landscape' style={{ orientation: 'landscape', }}>
            <View style={{ border: 2, margin: 20, padding: 50, flexGrow: 1, fontSize: 10 }}>
              <View style={{ marginLeft: 5, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Image src='/brasao.png' style={{ marginTop: -25, width: 110, height: 110, }} />
                <View style={{ marginLeft: 0, marginRight: 20, marginTop: 5, }}>
                  <View style={{ display: 'flex', alignItems: 'center' }}>
                    <Text style={{ fontSize: 14, lineHeight: 1.5 }}>Prefeitura Municipal de Porto Alegre</Text>
                    <Text style={{ fontSize: 12, lineHeight: 1.5 }}>Secretaria Municipal da Fazenda</Text>
                    <Text style={{ fontSize: 12, lineHeight: 1.5 }}>Receita Municipal</Text>
                  </View>
                </View>
                <Image src='/logo-compliance.png' style={{ marginTop: -20, width: 100, height: 100, }} />
              </View>
              <View style={{ marginTop: 15, display: 'flex', flexDirection: 'row', justifyContent: 'center', textTransform: 'uppercase' }}>
                <View>
                  <Text>
                    certificado de classificação no programa
                  </Text>
                </View>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', textTransform: 'uppercase' }}>
                <View>
                  <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 10, marginBottom: 5 }}>
                    <Text>
                      em dia com porto alegre
                    </Text>
                  </View>
                  <View style={{ marginTop: 10, marginBottom: 10, border: 1, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}></View>
                  <View style={{ display: 'flex', alignItems: 'center' }}>
                    <Text>
                      este certificado é válido de
                    </Text>
                    <Text style={{ marginTop: 5 }}>
                      {formatarData(validadeInicio)} até {formatarData(validadeFim)}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={{ width: 44, height: 44, border: 1.2, borderColor: 'black', backgroundColor: 'white', borderRadius: 50, marginTop: 25, marginLeft: 325, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <View style={{ width: 36, height: 36, border: 1.2, borderColor: 'black', backgroundColor: 'white', borderRadius: 50, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                  <Text style={{ color: 'black', fontSize: 20 }}>{classificacao}</Text>
                </View>
              </View>
              <View>
                <Text style={{ padding: 10, marginTop: 20, fontSize: 12, lineHeight: 1.5, textAlign: 'center' }}>
                  A Receita Municipal de Porto Alegre certifica que {razaoSocial}, CNPJ {cnpjMask(cnpj)}, na condição de {condicao}, observado o cumprimento de obrigações tributárias principais e
                  acessórias no período de {formatarData(aquisicaoInicio)} a {formatarData(aquisicaoFim)}, obteve classificação {classificacao} no Programa Municipal de Estímulo à Conformidade Tributária – Em Dia com Porto Alegre, instituído pela Lei Complementar n. 928/2021 e regulamentado pelo Decreto n. 21.479/2022.
                </Text>
                <Text style={{ padding: 10, marginTop: 20, textAlign: 'center' }}>
                  Certificado emitido em {formatarData(emitido)}, conforme Lei n. 928/2021 e Decreto n. 21.479/2022.
                </Text>
                <Text style={{ paddingLeft: 10, paddingRight: 10, marginTop: 5, textAlign: 'center' }}>
                  "A autenticidade deste certificado deverá ser verificada em
                </Text>
                <Text style={{ paddingLeft: 10, paddingRight: 10, textAlign: 'center' }}>
                  https://emdiacompoa-publico.portoalegre.rs.gov.br/, informando o código {codigo}”
                </Text>
              </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    );
  };
};

export default CertificateComponent;
